import {axiosInstance} from "../lib/axios";

class PartnersService {
  BASE_URL = "/partners";

  async listPartners(params = {}) {
    const {search, isActive, page = 1, limit = 10} = params;
    const {data} = await axiosInstance.get(this.BASE_URL, {
      params: {
        search: search || undefined,
        isActive: typeof isActive === "boolean" ? String(isActive) : undefined,
        page,
        limit,
      },
    });
    return data;
  }

  async getPartnerById(id) {
    const {data} = await axiosInstance.get(`${this.BASE_URL}/${id}`);
    return data;
  }

  async createPartner(payload) {
    const {data} = await axiosInstance.post(this.BASE_URL, payload);
    return data;
  }

  async updatePartner(id, payload) {
    const {data} = await axiosInstance.patch(`${this.BASE_URL}/${id}`, payload);
    return data;
  }

  async deletePartner(id) {
    const {data} = await axiosInstance.delete(`${this.BASE_URL}/${id}`);
    return data;
  }

  async togglePartnerActive(id, nextActive) {
    const {data} = await axiosInstance.patch(`${this.BASE_URL}/${id}`, {
      isActive: nextActive,
    });
    return data;
  }

  async assignUsers(id, userIds) {
    const {data} = await axiosInstance.post(`${this.BASE_URL}/${id}/users`, {
      userIds,
    });
    return data;
  }

  async unassignUsers(id, userIds) {
    const {data} = await axiosInstance.delete(`${this.BASE_URL}/${id}/users`, {
      data: {userIds},
    });
    return data;
  }

  async togglePartnerStatus(id) {
    const {data} = await axiosInstance.patch(
      `${this.BASE_URL}/${id}/toggle-status`
    );
    return data;
  }

  async getPartnerMembers(partnerId, params) {
    const {data} = await axiosInstance.get(
      `${this.BASE_URL}/${partnerId}/members`,
      {params}
    );
    return data;
  }
}

const partnersService = new PartnersService();
export default partnersService;
